import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { StepOneFormMessages as messages } from './StepOneForm.i18n';

export const validate = (formTarget) => {
  const errors = {};
  let idx = 0;
  for (idx; idx < formTarget.length; idx += 1) {
    if (formTarget[idx].type === 'text' && formTarget[idx].value === '') {
      errors[formTarget[idx].name] = <FormattedMessage { ...messages.form.error.required } />;
    }
  }
  return errors;
};

export const numericCharactersOnly = event => (
  event.charCode >= 48 && event.charCode <= 57
);

export const lessThanOrEqual = maxLimit => (event) => {
  if (!isNaN(maxLimit)) {
    const numberEntry = event.target.value + String.fromCharCode(event.charCode);
    if (!isNaN(numberEntry) && Number(numberEntry) <= Number(maxLimit)) {
      return true;
    }
  }
  return false;
};

export const handleKeyPress = validators => (event) => {
  let isValid = true;
  // All validators must return true otherwise isValid fails;
  let i = 0;
  for (i; i < validators.length; i += 1) {
    isValid = validators[i](event);
    if (!isValid) { break; }
  }

  if (!isValid) {
    event.preventDefault();
    event.stopPropagation();
  }
};

export const StepOneFieldBlock = (children, attribs) => {
  const xsSize = attribs.xsSize || 10;
  const mdSize = attribs.mdSize || 6;
  const id = attribs.id || 'keyId';
  return (<Row key={'row_' + id}>
    <Col xs={xsSize} md={mdSize} className="form-group" key={'col_' + id}>
      { children || null }
    </Col>
          </Row>);
};

export const ErrorTextBlock = (fieldId, error) => (
  <span>
    &nbsp;<span className="label label-danger header" data-qa-item={'req_' + fieldId}>
      {error || null}
          </span>
  </span>
);

export const StepOneInputFieldBlock = (attribs) => {
  const helpTextKey = 'hlp_' + attribs.id;
  const labelKey = 'label_' + attribs.id;
  const divKey = 'div_' + attribs.id;
  const inputId = attribs.id;

  const children = [
    <div key={divKey}>
      <label htmlFor={inputId} key={ labelKey }>
        {attribs.labelText}
        {attribs.error ? ErrorTextBlock(inputId, attribs.error) : null}
      </label>
      <input
        key={inputId}
        id={inputId}
        name={inputId}
        type={attribs.type}
        className="form-control"
        onKeyPress={attribs.onKeyPress}
        onChange={ attribs.onChange || {} }
        value={attribs.value}
        aria-describedby={helpTextKey}
        autoComplete={attribs.autocomplete || 'on'}
      />
      {attribs.helpText ?
        <span className="understated small" id={helpTextKey} key={helpTextKey}>
          { attribs.helpText }
        </span> : null}
      {attribs.addtlElements || null}
    </div>,
  ];

  return StepOneFieldBlock(children, attribs);
};

export const DobInputFieldBlock = (attribs) => {
  const divKey = 'div_' + attribs.id;
  const inputId = attribs.id;
  const helpTextScreenKey = 'label_' + attribs.id;
  const helpDescSRKey = 'desc_' + attribs.id;
  const ariaLabelledBys = 'label_dob ' + helpDescSRKey;

  return (<div className={attribs.className} key={divKey}>
    <input
      key={inputId}
      id={inputId}
      name={inputId}
      maxLength={attribs.maxLength || {}}
      className="form-control"
      type="text"
      onKeyPress={attribs.onKeyPress}
      onChange={ attribs.onChange || {} }
      value={attribs.value}
      aria-labelledby={ariaLabelledBys}
      autoComplete={attribs.autocomplete || 'on'}
    />
    <span className="small understated help-text" aria-hidden="true" key={helpTextScreenKey}>
      {attribs.helpText}
    </span>
    <label className="sr-only" id={helpDescSRKey} key={helpDescSRKey}>
      {attribs.helpDescription}
    </label>
          </div>);
};

export const DobBlock = (inputAttribs) => {
  const errorAttribs = inputAttribs.filter(attrib => attrib.error);

  let children = [<label id="label_dob" key="label_dob">
      <FormattedMessage {...messages.form.dob.label} />
      {errorAttribs && errorAttribs.length > 0 ? ErrorTextBlock('dob', errorAttribs[0].error) : null}
                  </label>];

  children = children.concat(inputAttribs.map(inputAttrib =>
    DobInputFieldBlock(inputAttrib)
  ));

  return StepOneFieldBlock(children, { id: 'dobBlockId', mdSize: 8, xsSize: 10 });
};
